//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../Mechatronics/Mechatronics.PhysicsConstraintBuilder.js";
import "../Mechatronics/Mechatronics.SelectPhysicsJoint.js";
import "../no/Expression.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"AxisJoint",0,"Mechatronics.SelectPhysicsJoint",0],[0,"AxisType",1,0],[0,"DirectionType",1,0],[0,"EnableLimitForce",1,0],[1,"ForwardForce",0,"Expression",0],[0,"LimitJerk",1,0],[1,"MaxAcceleration",0,"Expression",0],[1,"MaxJerk",0,"Expression",0],[0,"ParameterType",1,0],[1,"ReverseForce",0,"Expression",0],[1,"Signal",0,"SelectNXObject",0],[1,"Speed",0,"Expression",0],[0,"UseAcceleration",1,0]],[[["axis_joint"],"SetAxisJoint",{},1,0],[["signal"],"SetSignal",{},1,0],[["targetExp"],"SetTarget",{},1,0]],[]];
SPLM.Mechatronics.SpeedControlBuilder = class extends SPLM.Mechatronics.PhysicsConstraintBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.SpeedControlBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.SpeedControlBuilder.AxisJointType = Object.freeze({
    "Angular" : "Angular", "Linear" : "Linear", "Mixed" : "Mixed"});

export default SPLM;